import request from "@/config/_request";
import qs from "qs";

//获得置顶运营活动列表
export function activityTopList(params) {
    return request({
        url: "/api/get/top/run/activity/list",
        params,
        method: "get",
    });
}
//运营活动报名或取消报名接口
export function signUp(params) {
    return request({
        url: "/api/add/or/delete/run/activity/tch",
        data: qs.stringify(params),
        method: "post",

    });
}
//获得往期运营活动列表
export function activityList(params) {
    return request({
        url: "/api/get/past/run/activity/list",
        params,
        method: "get",
    });
}
//超管获得运营活动类型列表
export function typeList(params) {
    return request({
        url: "/api/get/run/activity/type/list",
        params,
        method: "get",

    });
}
//超管获得运营培训类型列表
export function listType(params) {
    return request({
        url: "/api/get/run/training/type/list",
        params,
        method: "get",
    });
}
//教师端获得运营培训列表
export function trainingList(params) {
    return request({
        url: "/api/get/run/training/list",
        params,
        method: "get",
    });
}
//教师端获得运营培训详情,调用改接口会自动保存用户的观看记录
export function trainingInfo(params) {
    return request({
        url: "/api/get/run/training/info",
        params,
        method: "get",
    });
}

//前端获得物料场景列表
export function sceneList(params) {
    return request({
        url: "/api/get/base/meterial/scene/list",
        params,
        method: "get",
    });
}
//获得物料列表
export function meterialList(params) {
    return request({
        url: "/api/get/base/meterial/list",
        params,
        method: "get",
    });
}
//获得物料详情
export function meterialInfo(params) {
    return request({
        url: "/api/get/base/meterial/info",
        params,
        method: "get",
    });
}
//增加文件下载次数
export function downloadNum(params) {
    return request({
        url: "/api/update/base/meterial/file/download/num",
        data: qs.stringify(params),
        method: "post",

    });
}

//增加文件下载次数
export function trainingDownloadNum(params) {
    return request({
        url: "/api/update/run/training/file/download/num",
        data: qs.stringify(params),
        method: "post",

    });
}